module.exports = __webpack_public_path__ + "assets/img/news (32).3b6be109.png";